import axiosInstance from '../../../shared/api/AxiosInstance';

export function listUsers(params) {
    return axiosInstance.get('/users', { params });
}

export function listDirectoryUsers(params) {
    return axiosInstance.get('/users/directory', { params });
}

export function getDirectoryUser(userId, params) {
    return axiosInstance.get(`/users/directory/${userId}`, { params });
}
